<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch8">
<div class="chapterHead"><p class="centerImage"><img alt="image" src="images/ch8.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;">You keep running and don’t look back. You don’t have to see him — now you can hear the Strangler’s footsteps behind you. “Hurry, Liz! He’s following us!”</p>
<p class="para" style="text-indent: 5%;">You run to the entrance door of the brick apartment building closest to you and try the handle. Locked!</p>
<p class="para" style="text-indent: 5%;">The Strangler is catching up.</p>
<p class="para" style="text-indent: 5%;">You hurry to the next door. Locked!</p>
<p class="para" style="text-indent: 5%;">The Strangler is closing in on you.</p>
<p class="para" style="text-indent: 5%;">Liz trips and stumbles. “My ankle!” she cries, hopping on one foot. “I twisted it!”</p>
<p class="para" style="text-indent: 5%;">The Strangler is gaining on you. You drag Liz to the next door. Locked! All locked. There’s only one building left to try. “Liz,” you say, pulling her along behind you, “come on, you’ve got to make it a little farther.”</p>
<p class="para" style="text-indent: 5%;">You reach the door of the last building. “There’s a candle burning in the window on the top floor,” you whisper hoarsely to Liz. “This one’s got to open for us!”</p>
<p class="extractLetterText" style="text-indent: 5%;"><em class="italic">Run for <span href="#/e9780545841733_ch079" title="Link target outside of Sample">PAGE 79</span>.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841733_ch008.vue?0be16c39